import { render, staticRenderFns } from "./logwood-shift-packages-table.vue?vue&type=template&id=3b7d3532&scoped=true&"
import script from "./logwood-shift-packages-table.vue?vue&type=script&lang=ts&"
export * from "./logwood-shift-packages-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d3532",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7d3532')) {
      api.createRecord('3b7d3532', component.options)
    } else {
      api.reload('3b7d3532', component.options)
    }
    module.hot.accept("./logwood-shift-packages-table.vue?vue&type=template&id=3b7d3532&scoped=true&", function () {
      api.rerender('3b7d3532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/components/logwood-shift-packages-table.vue"
export default component.exports